import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./cont_nat.css";
import navBarEn from "../../translations/en/navbar.json";
import navBarEs from "../../translations/es/navbar.json";
import Helmet from "react-helmet";
import ReactMarkdown from "react-markdown";

function NationalContract() {
  const [tNationalContract] = useTranslation("cont_nat");
  const [tLogisticsContract] = useTranslation("LogisticsContract");
  const [tSMetaData] = useTranslation("metaData");
  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].nationalContract}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].nationalContract}`
  );

  return (
    <>
      <Helmet>
        <title>{tSMetaData("contratoCargaAereaNacional.title")}</title>
        <meta
          name="description"
          content={tSMetaData("contratoCargaAereaNacional.description")}
        />
      </Helmet>
      <ScrollToTop />
      <Navbar />

      <div className="container-fluid backg-gray">
        <div className="row">
          <div className="col">
            {tNationalContract("nacional.subtitulo")}
          </div>
        </div>
      </div>

      <div className="container p-0 ps-3 ps-sm-0 btn-back-container">
        <div className="row">
          <div className="col">
            <Link className="btn-cont-nat" to="/contracts">
              {tNationalContract("nacional.button")}
            </Link>
          </div>
        </div>
      </div>

      <section className="container national-contract-container">
        <div className="row">
          <div className="col">
            <h1>{tNationalContract("nacional.titulo")}</h1>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo1")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo2")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo3")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo4")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo5")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo6")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo7")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo8")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo9")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo10")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo11")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo12")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo13")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo14")}
              </ReactMarkdown>
            </p>
            <p>
              <ReactMarkdown>
                {tLogisticsContract("parrafo15")}
              </ReactMarkdown>
            </p>
          </div>
        </div>
      </section>

      <div className="container p-0 ps-3 ps-sm-0 btn-back-container">
        <div className="row">
          <div className="col">
            <Link className="btn-cont-nat" to="/contracts">
              {tNationalContract("nacional.button")}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default NationalContract;
